import { ChangeDetectionStrategy, Component, computed, input, model, output } from '@angular/core';
import {
  AgentOfficeAddressDto,
  AgentOfficeHoursUpdateDto,
  AgentProfileDto,
  OpeningHoursDto,
} from '@workspace/data-types';
import { AuraEditWrapperComponent } from '@workspace/ng-aura';
import { AgentOfficeHoursDisplayComponent } from '../display/agent-office-hours-display.component';
import { AgentOfficeHoursFormComponent } from '../form/agent-office-hours-form.component';

@Component({
  selector: 'etxe-agent-office-hours-edit',
  imports: [AuraEditWrapperComponent, AgentOfficeHoursFormComponent, AgentOfficeHoursDisplayComponent],
  templateUrl: './agent-office-hours-edit.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AgentOfficeHoursEditComponent {
  readonly initialProfile = input<AgentProfileDto | null>(null);
  readonly officialAddress = input<string | null>(null);
  readonly isEditing = model<boolean>(false);
  readonly isAllowedToEdit = input<boolean>(true);

  readonly saved = output<AgentOfficeHoursUpdateDto>();
  readonly profileSaved = output<AgentProfileDto>();

  readonly resolvedOfficialAddress = computed<string | null>(() => {
    const direct = this.officialAddress();
    if (direct) return direct;
    const cardAddr = this.initialProfile()?.cards?.activeCard?.address;
    if (cardAddr && (cardAddr.streetName || cardAddr.city)) {
      const line1 = [cardAddr.streetNumber, cardAddr.streetType, cardAddr.streetName]
        .filter(Boolean)
        .join(' ');
      const line2 = [cardAddr.zipCode, cardAddr.city].filter(Boolean).join(' ');
      return [line1, cardAddr.complement, line2].filter(Boolean).join(', ');
    }
    return null;
  });

  readonly currentAddress = computed<AgentOfficeAddressDto | undefined>(() => {
    return this.initialProfile()?.work?.officeAddress;
  });

  readonly currentHours = computed<OpeningHoursDto | undefined>(() => {
    return this.initialProfile()?.work?.openingHours;
  });

  onSave(dto: AgentOfficeHoursUpdateDto | null): void {
    if (!dto) return;
    this.saved.emit(dto);
    const profile = this.initialProfile();
    if (profile) {
      this.profileSaved.emit({
        ...profile,
        work: {
          ...profile.work,
          officeAddress: dto.officeAddress,
          openingHours: dto.openingHours,
        },
      });
    }
  }
}
